// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__JEr6u","footerLinks":"Footer_footerLinks__bTIPS","footerCopyright":"Footer_footerCopyright__Xltgn"};